"use client";
import { Button } from "@/components/ui/button";
import { DialogTrigger } from "@/components/ui/dialog";
import { DrawerTrigger } from "@/components/ui/drawer";
import { VIEW_DETAILS_COLORS } from "./viewDetailsButtonColors";

export function ToggleButton({ type, variant = "dialog" }) {
  const Trigger = variant === "drawer" ? DrawerTrigger : DialogTrigger;

  return (
    <Trigger asChild>
      <Button
        size="xs"
        className="w-full"
        customColors={VIEW_DETAILS_COLORS}
      >
        View Details
      </Button>
    </Trigger>
  );
}
